import { render } from "./headerMonPermis.vue?vue&type=template&id=aaf450e8&scoped=true"
import script from "./headerMonPermis.vue?vue&type=script&lang=js"
export * from "./headerMonPermis.vue?vue&type=script&lang=js"

import "./headerMonPermis.vue?vue&type=style&index=0&id=aaf450e8&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaf450e8"]])

export default __exports__